// root
export const SET_RID = 'setRid'
export const SET_MODE = 'setMode'
export const SET_FB_USER = 'setFbUser'

// rooms
export const CLEAR_TEST_ROOMS = 'clearTestRooms'
export const CLEAR_PROD_ROOMS = 'clearProdRooms'
export const CLEAR_ROOMS = 'clearRooms'

// room
export const SET_ROOM = 'setRoom'
export const SET_ROOM_TYPE = 'setRoomType'
export const CLEAR_ROOM = 'clearRoom'

// watchers
export const CLEAR_WATCHERS = 'clearWatchers'

// chat
export const CLEAR_THREAD = 'clearThread'

// user
export const SET_USER = 'setUser'
export const SET_USER_STATUS = 'setUserStatus'

// media
export const SET_CONSTRAINTS = 'setConstraints'
export const SET_MAX_BANDWIDTH = 'setMaxBandwidth'
export const SET_CODEC = 'setCodec'
export const SET_SIMULCAST = 'setSimulcast'
export const CLEAR_MEDIA = 'clearMedia'

// quizzes
export const CLEAR_QUIZZES = 'clearQuizzes'
export const CLEAR_QUIZ_OF_TODAY = 'clearQuizOfToday'

// quizbank
export const CLEAR_QUIZ = 'clearQuizBank'

// result
export const CLEAR_RESULT = 'clearResult'
